/**
 * Meeting status codes
 */
export const MEETING_STATUS = {
  DRAFT: 'DRAFT',
  SCHEDULED: 'SCHEDULED',
  IN_PROGRESS: 'IN_PROGRESS',
  COMPLETED: 'COMPLETED',
  CANCELLED: 'CANCELLED',
};

/**
 * Statuses that indicate a meeting has ended
 */
const ENDED_STATUSES = [MEETING_STATUS.COMPLETED, MEETING_STATUS.CANCELLED];

/**
 * Check if a meeting status indicates the meeting has ended
 * @param {string} statusCode - The status code to check
 * @returns {boolean} True if the meeting has ended (COMPLETED or CANCELLED)
 */
export const isMeetingEnded = (statusCode) => {
  return ENDED_STATUSES.includes(statusCode);
};
